import { matchPath } from 'react-router-dom';
import { PATHS } from '@utils/paths';
import { kebabToCamelCase } from '@utils/strings';
import { Page } from './types';

export const caseAgnosticPages = [Page.security, Page.exports];

const isPageKey = (value: string): value is keyof typeof Page =>
  Object.hasOwn(Page, value);

const mapPathnameToPageKey = (
  pathSegment?: string,
): keyof typeof Page | undefined => {
  if (!pathSegment) return undefined;
  const normalizedSegment = kebabToCamelCase(pathSegment);
  return isPageKey(normalizedSegment) ? normalizedSegment : undefined;
};

const productPages = [
  { path: PATHS.PRIVATE_BASE.claimFiles, page: Page.files },
  { path: PATHS.PRIVATE_BASE.scheduledReports, page: Page.scheduledReports },
  {
    path: PATHS.PRIVATE_BASE.claimscoreSettings,
    page: Page.claimscoreSettings,
  },
];

export const getPage = (pathname: string, firstSegment?: string): Page => {
  const productPage = productPages.find(({ path }) =>
    matchPath({ path, end: false }, pathname),
  )?.page;
  if (productPage) return productPage;

  const pageKey = mapPathnameToPageKey(firstSegment);
  return pageKey ? Page[pageKey] : Page.dashboard;
};
